export function getView(is_full_width) {
  return is_full_width ? 'Expanded' : 'Condensed'
}
